"use client";
import {m, AnimatePresence} from "framer-motion";
import {GoSun, GoMoon} from "react-icons/go";
import {useTheme} from "@/context/ThemeProvider";

export default function ThemeToggle() {
  const {theme, setTheme} = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="relative flex items-center justify-center w-9 h-9 border-2 border-zinc-800 bg-zinc-950 text-zinc-400 hover:text-yellow-400 hover:border-yellow-400 transition-none cursor-pointer rounded-none hover-glitch"
    >
      <AnimatePresence mode="wait">
        {isDark ? (
          <m.span
            key="sun"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.1}}
          >
            <GoSun size={16} />
          </m.span>
        ) : (
          <m.span
            key="moon"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.1}}
          >
            <GoMoon size={16} />
          </m.span>
        )}
      </AnimatePresence>
    </button>
  );
}
